import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'search',
  standalone: true,
})
export class SearchPipe implements PipeTransform {
  search;

  transform<T>(value: T[], search?: string, onlyValues?: boolean, onlyProperties?: string[]): T[] {
    if (!search) {
      return value;
    }
    this.search = this.escapeRegExp(search).split(' ');
    return value.filter(v => {
      let found = true;
      this.search.forEach(str => {
        if(onlyValues) {
          let strToSearch = [];
          if(onlyProperties) {
            strToSearch = onlyProperties.map(key => v[key])
          } else {
            strToSearch = Object.values(v);
          }
          found = found && (strToSearch.join(' ').normalize("NFD").search(new RegExp(str, 'i')) !== -1);
        } else {
          found = found && (JSON.stringify(v).normalize("NFD").search(new RegExp(str, 'i')) !== -1);
        }
      });
      return found;
    });
  }

  escapeRegExp(str): string {
    return str.normalize("NFD").replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
